<template>
    <header class="border-second">
        <div class="container">
            <div class="d-flex justify-content-between align-items-center flex-wrap py-3">
                <div class="col-12 col-sm-4 text-center text-sm-start mb-2 mb-sm-0">
                    <a href="https://autoguidovie.it/">
                        <img :src="require(`@/assets/img/tenants/${omsApiKey}.png`)" class="w-50" alt="AUTOGUIDOVIE">
                    </a>
                </div>
                <div class="col-12 col-sm-4 text-center text-sm-end">
                    <LanguagesSelect class="select-auth"/>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters } from 'vuex'
import LanguagesSelect from '@/components/LanguagesSelect.vue'
export default {
    name: 'HeaderComp',
    components: {
        LanguagesSelect
    },
    computed: {
        ...mapGetters(['omsApiKey'])
    }
}
</script>

<style lang="scss" scoped>
    header {
        border-bottom: 10px solid;
    }
</style>